<template>
  <ModalDialog v-model="showDiscardModal" :closeOnEsc="true" :showXCloseButton="true">
    <RichText class="richtext" :field="description" />
    <div class="flex flex-col gap-4 mt-8">
      <FormKit
        type="button"
        inputClass="btn btn-primary btn-md w-full"
        label="No"
        @click="() => (showDiscardModal = false)"
      />
      <FormKit
        type="button"
        :loading="isLoading"
        inputClass="btn btn-secondary btn-md w-full"
        label="Yes"
        @click="discardChanges"
      />
    </div>
  </ModalDialog>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-vue';
import ModalDialog from '../ModalDialog/ModalDialog.vue';
import { QuoteSessionService as _quoteSessionService } from '@/services/store/quote-session.service';
import { JP_GENERIC_CODE } from '@/constants/jeopardy-codes.const';
import { useAccountStore, useJeopardyStore } from '@/store';

const props = defineProps<{
  description: Field<string>;
  showByDefault?: boolean;
}>();

// Define Component state
// ------------------------------------------------------------- //
const accountStore = useAccountStore();
const jpStore = useJeopardyStore();

const showDiscardModal = ref(false);
const isLoading = ref(false);

const quoteSessionId = computed(() => {
  const params = new URLSearchParams(location.search);
  return params.get('quoteSessionId') ?? '';
});

// Lifecycle hooks
// ------------------------------------------------------------- //
onMounted(() => {
  if (props.showByDefault) {
    showDiscardModal.value = true;
  }
});

// Define Functions
// ------------------------------------------------------------- //
async function withdrawQuoteSession() {
  const response = await _quoteSessionService.withdrawQuoteSession(quoteSessionId.value ?? '');
  if (response.errors && response.errors.length > 0) {
    throw response.errors[0].message ?? JP_GENERIC_CODE;
  }
  return response;
}
function showJeopardyPanel(jpCode: string) {
  jpStore.showJeopardyPanel({
    jpCode: jpCode,
  });
}

async function discardChanges() {
  try {
    isLoading.value = true;
    await withdrawQuoteSession();
    await accountStore.cancelForm();
    isLoading.value = false;
    showDiscardModal.value = false;
  } catch (e) {
    console.error('Error discarding session quote', e);
    showJeopardyPanel(e as string);
  } finally {
    isLoading.value = false;
    showDiscardModal.value = false;
  }
}

function showHideModal(show: boolean) {
  showDiscardModal.value = show;
}

defineExpose({
  showHideModal,
});
</script>
